import { string, object, number, ref } from "yup";

import addressSchema from "../../../utils/common-schemas/Address-schema";

const email = string().email();

const crecheInformationSchema = object().shape({
  nom: string().required("Le nom est obligatoire"),
  logoId: string(),
  adresseCreche: addressSchema
});

const agentSchema = object().shape({
  nom: string().required("Le nom est obligatoire"),
  prenom: string().required("Le prénom est obligatoire"),
  email: email.required("L'email est obligatoire"),
  numeroTel: number(),
  fonction: string()
});

const accountInformationSchema = object().shape({
  identifiant: email.required("l'identifiant est obligatoire"),
  motDePasse: string()
    .required("le mot de passe est obligatoire")
    .min(
      8,
      "Le mot de passe est trop court - il devrait contenir au moins 8 caractères."
    ),
  comfirmerMotDePasse: string()
    .required("confirmer le mot de passe est obligatoire")
    .oneOf(
      [ref("motDePasse"), null],
      "Mot de passe et confirmer le mot de passe ne correspond pas"
    ),
  agentCrecheDto: agentSchema
});

const crecheSchema = object().shape({
  crecheDto: crecheInformationSchema,
  compteRequestDto: accountInformationSchema
});

export const createCrecheSchema = (t) => {
  const tEmail = string().email();

  const tCrecheInformationSchema = object().shape({
    nom: string().required(t("validation.nom_required")),
    logoId: string(),
    adresseCreche: object().shape({
      rue: string().required(t("validation.address_rue_required")),
      ville: string().required(t("validation.address_ville_required")),
      codePostale: number()
        .typeError(t("validation.address_code_postal_required"))
        .min(1, t("validation.address_code_postal_required"))
        .required(t("validation.address_code_postal_required")),
      pays: string()
    })
  });

  const tAgentSchema = object().shape({
    nom: string().required(t("validation.nom_required")),
    prenom: string().required(t("validation.prenom_required")),
    email: tEmail.required(t("validation.email_required")),
    numeroTel: number(),
    fonction: string()
  });

  const tAccountInformationSchema = object().shape({
    identifiant: tEmail.required(t("validation.identifiant_required")),
    motDePasse: string()
      .required(t("validation.password_required"))
      .min(8, t("validation.password_too_short")),
    comfirmerMotDePasse: string()
      .required(t("validation.confirm_password_required"))
      .oneOf(
        [ref("motDePasse"), null],
        t("validation.passwords_not_matching")
      ),
    agentCrecheDto: tAgentSchema
  });

  return object().shape({
    crecheDto: tCrecheInformationSchema,
    compteRequestDto: tAccountInformationSchema
  });
};

export default crecheSchema;
